import { takeLatest, put, call } from 'redux-saga/effects';

import * as actionTypes from './actionTypes';
import * as api from './api';

export function* checksSaga() {
  yield takeLatest(actionTypes.FETCH_DATA, fetchData);

  yield takeLatest(actionTypes.REQUEST_UPDATE_RECORD, updateRecordWatcher);
  yield takeLatest(actionTypes.REQUEST_DELETE_RECORD, removeRecordWatcher);

  yield takeLatest(actionTypes.FETCH_NEXT_CHECKS, fetchNextChecks);

  yield takeLatest(actionTypes.FETCH_ONLY_CATEGORIES, fetchCategories);
}

function* fetchData({ pageSize, sort }) {
  yield put({ type: actionTypes.FETCH_DICTIONARIES_CATEGORIES });
  yield put({ type: actionTypes.FETCH_FILTERS });
  yield put({ type: actionTypes.FETCH_CHECKS });

  {
    const { data: categoriesDictornary } = yield call(api.fetchCategoriesDictionary);

    yield put({
      type: actionTypes.FETCH_DICTIONARIES_CATEGORIES_SUCCESS,
      payload: categoriesDictornary,
    });
  }

  try {
    // !! Следующие два запроса должны идти последовательно
    const receipts = yield call(api.fetchReceipts, { size: pageSize, sort });
    const filters = yield call(api.fetchFilters);

    yield put({ type: actionTypes.FETCH_FILTERS_SUCCESS, payload: filters });
    yield put({ type: actionTypes.FETCH_CHECKS_SUCCESS, payload: receipts });
  } catch (error) {
    yield put({ type: actionTypes.FETCH_CHECKS_FAILURE, error });
  }
}

function* fetchNextChecks({ options }) {
  yield put({ type: actionTypes.FETCH_CHECKS });
  try {
    const receipts = yield call(api.fetchReceipts, options);
    yield put({ type: actionTypes.FETCH_CHECKS_SUCCESS, payload: receipts });
  } catch (error) {
    yield put({ type: actionTypes.FETCH_CHECKS_FAILURE, error });
  }
}

function* updateRecordWatcher({ id, record: delta }) {
  yield put({ type: actionTypes.START_RECORD_PROCESS, payload: { id } });

  try {
    yield call(api.updateRecord, id, delta);

    yield put({ type: actionTypes.UPDATE_CHECK, payload: { id, delta } });
  } catch (error) {
    yield put({ type: actionTypes.ERROR_RECORD_PROCESS, payload: { id, error } });
  } finally {
    yield put({ type: actionTypes.FINISH_RECORD_PROCESS, payload: { id } });
  }
}

function* removeRecordWatcher({ id }) {
  yield put({ type: actionTypes.START_RECORD_PROCESS, payload: { id } });

  try {
    yield call(api.removeRecord, id);

    yield put({ type: actionTypes.DELETE_CHECK, payload: { id } });
  } catch (error) {
    yield put({ type: actionTypes.ERROR_RECORD_PROCESS, payload: { id, error } });
  } finally {
    yield put({ type: actionTypes.FINISH_RECORD_PROCESS, payload: { id } });
  }
}

function* fetchCategories() {
  yield put({ type: actionTypes.FETCH_DICTIONARIES_CATEGORIES });

  const { data: categoriesDictornary } = yield call(api.fetchCategoriesDictionary);

  yield put({
    type: actionTypes.FETCH_DICTIONARIES_CATEGORIES_SUCCESS,
    payload: categoriesDictornary,
  });
}
